import { Store } from 'redux';

import { Dispatch, State } from 'redux/types';

export type AppStore = Store<State> & { dispatch: Dispatch };

/**
 * Holds a reference to the Redux store so non-component, non-thunk code can
 * reach `getState`/`subscribe` without importing `redux/store` directly.
 *
 * Importing `redux/store` from a slice's `actions.ts` creates a circular
 * import: the store module imports the root reducer, which imports every
 * slice. This accessor module has no other imports, so depending on it is
 * cycle-free. `redux/store` calls `registerStore` once the store is built.
 */
let store: AppStore | undefined;

export const registerStore = (instance: AppStore): void => {
  store = instance;
};

export const getStore = (): AppStore => {
  if (!store) {
    throw new Error('Redux store accessed before it was registered');
  }

  return store;
};
